import { ROUTES } from "~/constants/routing";
import { LIFETIME_PREMIUM_LINK } from "~/constants/socials";

export const resolveAuthRedirectUrl = (
  pathname: string,
  href: string
): string =>
  pathname === LIFETIME_PREMIUM_LINK
    ? new URL(ROUTES.main.createURL(), href).href
    : href;
